import { type Configuration } from '@reliance/types/models/Configuration';
import { type ApiService } from '../types/ApiService';

export const configuration = (siteApi: ApiService) => ({
  get: (key?): Promise<Configuration> => {
    return siteApi.get('/configuration', { params: { key } });
  },
});
